import { useState } from "react";
import "./auth.scss";
import LoginPage from "./login/Login";
import OTPComponent from "./otp/OTP";
import ForgotPassword from "./forgotPassword/ForgotPassword";
import ResetPassword from "./resetPassword/ResetPassword";
import OTPComponents from "./forgotPassword/OTP";

const componentMap = {
  1: LoginPage,
  2: OTPComponent,
  3: ForgotPassword,
  5: ResetPassword,
  6: OTPComponents,
};

const Auth = () => {
  const [step, setSteps] = useState(1);
  const [data, setData] = useState({});
  const Component = componentMap[step];

  return (
    <>
      {Component && (
        <Component setSteps={setSteps} data={data} setData={setData} />
      )}
    </>
  );
};

export default Auth;
